import React from "react";
import { List } from "antd";
import VehicleDescription from "@/components/VehicleDescription";

const VehiclesSummaryList = ({ shipment }) => {
  const { vehicles } = shipment ?? [];

  return (
    <div>
      <span style={{ fontSize: 16, fontWeight: "bold" }}>
        {`${vehicles.length} Vehicle${vehicles.length > 1 ? "s" : ""}`}
      </span>
      <List
        dataSource={vehicles}
        rowKey={item => item.id}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={
                <VehicleDescription
                  vehicle={{
                    ...item,
                    shipment: {
                      trailerType: shipment.trailerType,
                      availableAt: shipment.availableAt,
                    },
                    gatePassType: item.gatePassType,
                    gatePassUrl: item.gatePassUrl,
                  }}
                  withTags
                />
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default VehiclesSummaryList;
